import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexModule } from '@ngbracket/ngx-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { AlertModule, CheckboxModule, FormErrorModule, InputModule } from '@eg/ui';
import { AdditionalSurchargeComponent } from './additional-surcharge.component';
import { AdditionalSurchargeFormService } from './additional-surcharge.service';

@NgModule({
  declarations: [AdditionalSurchargeComponent],
  imports: [CommonModule, CheckboxModule, FormErrorModule, InputModule, FlexModule, ReactiveFormsModule, TranslocoModule, AlertModule],
  providers: [AdditionalSurchargeFormService],
  exports: [AdditionalSurchargeComponent],
})
export class AdditionalSurchargeModule {}
